module.exports = __webpack_public_path__ + "static/img/image-metal-pack@2x.59807e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expansion/image-metal-pack@2x.png
// module id = 9pGQ
// module chunks = 12